import React from 'react';
import {
  tooltipContainerStyle,
  tooltipTitleStyle,
  tooltipLabelStyle,
  tooltipValueStyle,
} from '../../utils/chartTheme';

interface ChineseTooltipProps {
  seriesIndex: number;
  dataPointIndex: number;
  w: any;
  selectedCurrency: string;
  priceView?: 'kg' | 'box';
  isDark?: boolean;
}

const ChineseTooltip: React.FC<ChineseTooltipProps> = ({
  seriesIndex,
  dataPointIndex,
  w,
  selectedCurrency,
  priceView = 'kg',
  isDark = false,
}) => {
  // Obtener el valor x del punto de datos
  const xValue = w.globals.seriesX[seriesIndex][dataPointIndex];

  // Convertir de índice (0-21) a semana (-18 a +3)
  const weekNumber = xValue - 18;



  const weekLabel = `Week ${weekNumber > 0 ? '+' : ''}${Math.round(
    weekNumber
  )}`;

  let content = `
    <div style="${tooltipContainerStyle(isDark)}">
      <div style="${tooltipTitleStyle(isDark)} margin-bottom: 8px;">
        ${weekLabel} from Chinese New Year
      </div>
  `;

  const sortedSeriesData = w.globals.seriesNames
    .map((name, index) => ({
      name,
      value: w.globals.series[index][dataPointIndex],
      color: w.globals.colors[index],
    }))
    .filter(({ value }) => value !== null && !isNaN(value))
    .sort((a, b) => b.value - a.value);

  sortedSeriesData.forEach(({ name, value, color }) => {
    content += `
      <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
        <div style="display: flex; align-items: center;">
          <span style="
            display: inline-block;
            width: 8px;
            height: 8px;
            background-color: ${color};
            border-radius: 50%;
            margin-right: 8px;
          "></span>
          <span style="${tooltipLabelStyle(isDark)}">${name}:</span>
        </div>
        <span style="${tooltipValueStyle(isDark)}">
          ${typeof value === 'number' ? value.toFixed(2) : 'N/A'} 
          ${selectedCurrency}/${priceView === 'kg' ? 'Kg' : '5kg box'}
        </span>
      </div>
    `;
  });

  content += '</div>';
  return content;
};

export default ChineseTooltip;
